import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {LoadingSpinner} from "../../../../../ui/LoadingSpinner";
import {apiEditAddress} from "../../../../../../client/state/UserAddressStore";
import {AddressForm} from "../../../../../website/authenticated/pages/account/components/address/AddressForm";
import {addressController} from "../../../../inline-subscription/AddressController";

export class EditAddressComponent extends UI.Element {
    render() {
        return <AddressForm ref="form" address={addressController.selectedAddress}/>;
    }

    isValid() {
        return true;
    }

    async getAddress() {
        if (!this.form.validateInputs()) {
            throw null;
        }
        LoadingSpinner.show();
        try {
            return await apiEditAddress({...this.form.getValues(), userAddressId: addressController.selectedAddress.id });
        } catch (error) {
            if (error?.fields) {
                this.form.displayFieldErrors(error);
                throw null;
            } else {
                throw error;
            }
        } finally {
            LoadingSpinner.hide();
        }
    }
}
